namespace GeniuzPOS.ReportMasterData {
    export class Report_1301Columns {
        static columnsKey = 'ReportMasterData.Report_1301';
    }
}
